module.exports = __webpack_public_path__ + "img/img-empty-state-colab.c2444ec1.svg";